import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';

import {
  CircularProgress,
  Grid,
  Typography,
  Button,
} from '@material-ui/core';
import EndIcon from '@material-ui/icons/Lens';

import Alert from '../../common/components/Alert';
import MainLayout from '../../common/components/MainLayout';
import EventListItem from '../components/EventListItem';

import * as mainActions from '../actions';
import classes from '../../css/getCSS';


class Events extends Component {
  componentDidMount() {
    document.title = 'Events';
    window.scrollTo(0, 0);
    this.props.deepUnmount();
    this.props.getEvents(this.props.site.id);
  }

  componentWillUnmount() {
    this.props.deepUnmount();
  }

  render() {
    let loading = null;

    if (this.props.loading) {
      loading = (
        <div align="center" style={{ marginTop: '50px' }}>
          <CircularProgress align="center" size={50} /> <br />
          <Typography variant="body1">Loading. Please wait</Typography>
        </div>
      );
    }

    let errorAlert = null;
    if (this.props.error) {
      errorAlert = <Alert type="danger">{this.props.error}</Alert>;
    }

    let list = null;
    if (this.props.count > 0) {
      list = this.props.eventList.map((item) => {
        return (
          <EventListItem
            key={item.id}
            {...item}
          />
        );
      });
    }

    let listEnd = null;
    if (!this.props.next && this.props.count > 0) {
      listEnd = (
        <div align="center" style={{ marginTop: '20px' }}>
          <EndIcon className={classes.endIcon} />
        </div>
      );
    }

    let nextLoader = null;
    if (this.props.next) {
      nextLoader = (
        <div align="center" style={{ marginTop: '20px' }}>
          <Button variant="contained" color="primary" onClick={() => this.props.getEvents(this.props.site.id, this.props.next)}>Load More</Button>
        </div>
      );
    }

    let rootClass = null;
    if (this.props.token) {
      rootClass = classes.dashboardLayout;
    }

    return (
      <MainLayout rootClass={rootClass} isAuthenticated={this.props.token !== null}>
        <Grid container style={{ justifyContent: 'center' }}>
          <Grid item md={6} sm={8} xs={12}>
            <Typography variant="display1">Events</Typography>
            <span className={classes.titleUnderline} />
            {list}
            {loading}
            {errorAlert}
            {nextLoader}
            {listEnd}
          </Grid>
        </Grid>
      </MainLayout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    site: state.common.site,
    token: state.auth.token,
    loading: state.main.loading,
    error: state.main.error,
    eventList: state.main.eventList,
    count: state.main.count,
    next: state.main.next,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUnmount: () => dispatch(mainActions.onUnmount()),
    deepUnmount: () => dispatch(mainActions.deepUnmount()),
    getEvents: (siteID, url) => dispatch(mainActions.getEvents(siteID, url)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Events));



// WEBPACK FOOTER //
// ./src/main/containers/Events.js